// extracted by mini-css-extract-plugin
export var container = "LongformHero-module--container--peaQX";